<template>
  <v-container
    id="contact"
    class="pa-0 grey lighten-3 flex-wrap align-start fill-height"
    fluid
    tag="section"
  >
    <v-row
      class="ma-0"
      justify="center"
    >
      <v-col
        cols="12"
        md="4"
      >
        <div class="my-6" />

        <h1 class="display-1 mb-8">
          Contact AECS
        </h1>

        <div class="mb-8">
          If you would like to book a counselling session, or would like further information about the
          therapies I offer, please contact me by phone, e-mail, or by completing the form.
        </div>

        <div class="mb-8">
          I provide face-to-face, telephone, and online counselling. Face-to-face counselling is provided in Rhyl, North Wales.
          Telephone and online counselling is provided to anyone in the UK.
        </div>

        <div class="mb-8">
          I offer a confidential, <b>free 15-minute telephone consultation</b> to see whether counselling is the right choice for you,
          and for you to see whether I am the right therapist for you.
        </div>

        <div class="mb-8">
          I look forward to hearing from you.
        </div>

        <div class="mb-4">
          <strong>Telephone:</strong> <a href="tel:07414247922">07414 247922</a>
        </div>

        <div class="mb-4">
          <strong>e-Mail:</strong> <a href="mailto:cheryl@aecs.org.uk">cheryl@aecs.org.uk</a>
        </div>
      </v-col>

      <v-col
        cols="12"
        md="5"
      >
        <v-form
          ref="form"
          novalidate="true"
          @submit.prevent="sendMail"
        >
          <v-row
            v-if="errors.length"
          >
            <v-col
              cols="12"
              md="12"
            >
              <v-sheet
                color="error"
                fore
                rounded
                class="pa-3 white--text"
              >
                <p class="font-weight-bold">
                  Sorry, your message has not been sent.
                </p>
                <p>So that I can reply to you, please correct the following and press Send Message again:</p>
                <ul>
                  <li
                    v-for="error in errors"
                    :key="error"
                  >
                    {{ error }}
                  </li>
                </ul>
              </v-sheet>
            </v-col>
          </v-row>
          <v-row class="mb-6">
            <v-col
              cols="12"
              md="6"
            >
              <v-sheet>
                <v-text-field
                  v-model="from_name"
                  hide-details
                  label="Your Name"
                  flat
                  solo
                  name="from_name"
                  required
                  outlined
                  type="text"
                />
              </v-sheet>
            </v-col>

            <v-col
              cols="12"
              md="6"
            >
              <v-sheet>
                <v-text-field
                  v-model="from_email"
                  hide-details
                  label="E-mail Address"
                  flat
                  solo
                  name="from_email"
                  required
                  outlined
                  type="email"
                />
              </v-sheet>
            </v-col>

            <v-col cols="12">
              <v-sheet>
                <v-textarea
                  v-model="message"
                  hide-details
                  label="Message"
                  flat
                  solo
                  name="message"
                  required
                  outlined
                  no-resize
                  rows="8"
                  type="text"
                />
              </v-sheet>
            </v-col>
          </v-row>

          <v-btn
            v-if="!success && !failed"
            :block="$vuetify.breakpoint.smAndDown"
            class="white--text"
            color="teal"
            type="submit"
            x-large
          >
            Send Message
          </v-btn>

          <v-overlay
            v-if="sending"
          >
            <v-progress-circular
              v-overlay
              indeterminate
              size="64"
            />
          </v-overlay>

          <v-alert
            v-if="success"
            type="success"
          >
            Thank you for your message. I will be in contact with you as soon as possible.
          </v-alert>

          <v-alert
            v-if="failed"
            type="error"
          >
            Sorry your message was not sent correctly - there is an issue with this web server.
            Please try again later or contact me by phone or e-mail.
          </v-alert>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import emailjs from '@emailjs/browser'

  export default {
    name: 'Contact',
    data () {
      return {
        errors: [],
        from_name: '',
        from_email: '',
        message: '',
        sending: false,
        success: false,
        failed: false,
      }
    },
    methods:
      {
        validEmail: function (email) {
          const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return re.test(email)
        },
        sendMail (e) {
          this.errors = []
          if (!this.from_name) {
            this.errors.push('Please give Your Name')
          }
          if (!this.from_email) {
            this.errors.push('Please give your E-mail Address')
          } else if (!this.validEmail(this.from_email)) {
            this.errors.push('Please give a valid E-mail Address')
          }
          if (!this.message) {
            this.errors.push('Please include a Message')
          }
          if (this.errors.length) {
            e.preventDefault()
            return
          }

          this.sending = true
          emailjs.send('service_n0upvs9', 'template_lvneeac',
                       {
                         from_name: this.from_name,
                         from_email: this.from_email,
                         message: this.message,
                       }, 'jrhoZ2ySMRxqIz_Ha')
            .then((_) => {
              this.sending = false
              this.success = true
              this.failed = false
            }, (_) => {
              this.success = true
              this.sending = false
              this.failed = false
            })
        },
      },
  }
</script>
